import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconType } from '@nibtravel/shared/ui/components/icon';
import { IconPosition } from '@nibtravel/shared/ui/components/link-icon';

@Component({
  selector: 'nibtravel-domestic-international-alert',
  templateUrl: './domestic-international-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DomesticInternationalAlertComponent {
  @Input() alertText!: string;

  icon = IconType;
  position = IconPosition;
}
